import { render, staticRenderFns } from "./EPGEntries.vue?vue&type=template&id=abdba5a4&"
import script from "./EPGEntries.vue?vue&type=script&lang=js&"
export * from "./EPGEntries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports